import React from 'react';
import './AboutMe.css';

const AboutMe: React.FC = () => {
  return (
    <section id="about" className="about-me">
      <h2>About Me</h2>
      <p>
        Master’s student in Distributed Systems at the University of São Paulo (USP) / ICMC (2025 – present). Currently a member of the Laboratory of Distributed Systems and Concurrent Programming (LaSDPC).
Scientific initiation student in mathematical modeling, computer vision, and high-performance computing (2021 – 2024).
Graduated in Computer Science from the Federal University of Western Pará (2019 – 2024).
      </p>
    </section>
  );
};

export default AboutMe;
